<app-breadcrumb [title]="'Listado Modelo'" [items]="['Vehiculos', 'Marca']"
  [active_item]="'Listado Modelo'"></app-breadcrumb>
<div class="container-fluid">

  <div class="card">
    <div class="card-header bg-primary text-white">
      <h5 class="text-uppercase">
       <strong>Listado de Modelos ACTIVOS</strong>
      </h5>
    </div>

    <div class="card-body custom-datatable noscroll">
      <div class="row mb-12 ">
        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
            </span>
          </div>
        </div>
      </div>
      <div class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered" id="tblModelo">
          <thead class="bg-primary">
            <tr>
              <th class="text-center" style="cursor: pointer" (click)="sortData('modelo')">
                <strong>MODELOS</strong>
                <i class="fa" [ngClass]="{
                      'fa-sort-up': sortedColumn === 'modelo' && sortDirection === 'asc',
                      'fa-sort-down': sortedColumn === 'modelo' && sortDirection === 'desc',
                      'fa-sort': sortedColumn !== 'modelo'
                    }"></i>
              </th>
              <th class="text-center" style="cursor: pointer"><strong>OPCIONES</strong></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let modelo of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
              <td class="text-center">{{ modelo.modelo }}</td>


              <!-- Buscar tarjeta correspondiente -->
              <td>
                <div class="action text-center">
                  <ul class="list-inline d-flex justify-content-center gap-3">
                    <!-- Editar -->
                    <li class="list-inline-item edit">
                      <a href="javascript:void(0)" title="Editar">
                        <i class="icon-pencil-alt" (click)="openModalModelo(myModal3, modelo.id)"
                          ngbTooltip="Editar"></i>
                      </a>
                    </li>

                    <!-- Eliminar -->
                    <li class="list-inline-item delete">
                      <a href="javascript:void(0)" title="Eliminar">
                        <i class="icon-trash" (click)="actualizarEstadoAInactivo(modelo.id)" ngbTooltip="Inactivar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ modelos.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
      <div class="card-body">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
            (click)="
                exportarExcel(
                  'tblMarcas',
                  'Listado_Marcas'
                )
              ">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
                exportToPDF(
                  'tblMarcas',
                  'Listado_Marcas',
                  'Listado de Marcas'
                )
              ">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>

          <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Crear"
            (click)="openModalModelo(myModal3)">
            <i class="icofont icofont-plus"></i> Crear
          </button>
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #myModal3 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR MODELO' : 'CREACIÓN DE MODELO' }}
      </h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formModelo">
        <div class="row g-3 mb-3">
          <div class="col-md-12">
            <label class="form-label" for="modelo"><strong>Modelo *:</strong></label>
            <input class="form-control" id="modelo" type="number" placeholder="Ingrese el modelo (YYYY)" max="9999"
              oninput="if(this.value.length > 4) this.value = this.value.slice(0, 4);" formControlName="modelo"
              autocomplete="off" />
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarModelo()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>